import {IptPhase} from '../../model/team/IptPhase';
import {TeamRoleSetting} from '../../model/team/TeamRoleSetting';

export class GetTeamRoles {

  id: string;
  name: string;
  tooltip: string;
  settings: {
    [IptPhase.DEVELOPMENT_INITIAL]: TeamRoleSetting,
    [IptPhase.DEVELOPMENT_CLOSING]: TeamRoleSetting,
    [IptPhase.CONSTRUCTION]: TeamRoleSetting,
    [IptPhase.OPERATIONS]: TeamRoleSetting,
  };

}
